(function () {

    'use strict';

    angular.module('iplusjs.filecache', [
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.misc'
    ])
    .service('FilecacheService', FilecacheService);

    FilecacheService.$inject = [
        '$window',
        'lodash',
        'MiscUtilsService',
        'AppConfig'
    ];
    function FilecacheService($window, _, MiscUtilsService, AppConfig) {
        var that = this,
            cachedFiles = [];

        that.addFile = addFile;
        that.getFile = getFile;
        that.removeFile = removeFile;
        that.resetFiles = resetFiles;

        function _initFile(file) {
            if (file.type === 'report' && file.filename) {
                file.fileUrl = [
                    $window.location.origin,
                    AppConfig.APP.urls.dms,
                    file.filename
                ].join('/');
            }

            if (file.fileUrl && MiscUtilsService.existsAdobeAcrobatPlugin()) {
                file.url = file.fileUrl || file.blobUrl;
            } else {
                file.url = file.blobUrl || file.fileUrl;
            }

            return file;
        }

        function _getFileIndex(name, type) {
            return _.findIndex(cachedFiles, {
                name: name,
                type: type
            });
        }
        function addFile(file) {
            if (_.isEmpty(file)) {
                return;
            }

            file = _initFile(file);

            var index = _getFileIndex(file.name, file.type);

            if (index !== -1) {
                cachedFiles.splice(index, 1, file);
            } else {
                cachedFiles.push(file);
            }

            return file;
        }
        function getFile(name, type) {
            var index = _getFileIndex(name, type);
            return index !== -1 ? cachedFiles[index] : null;
        }
        function removeFile(name, type) {
            var index = _getFileIndex(name, type);

            if (index !== -1) {
                cachedFiles.splice(index, 1);
            }
        }
        function resetFiles() {
            cachedFiles = [];
        }
    }
})();
